import { render, staticRenderFns } from "./CardioEcostressView.vue?vue&type=template&id=cb9276e6"
import script from "./CardioEcostressView.vue?vue&type=script&lang=js"
export * from "./CardioEcostressView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports